import { CompanyPartner } from '@interfaces/common/company';

/** Separador dos cargos de uma mesma pessoa na qualificação (igual ao `CompanyPartnerDeduplicator` do backend). */
export const PARTNER_QUALIFICATION_SEPARATOR = ' / ';

function normalizePartnerName(value: string): string {
  return value.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
}

function mergeQualifications(current: string, incoming: string): string {
  if (!incoming?.trim()) return current;
  if (!current?.trim()) return incoming.trim();
  const parts = current
    .split(PARTNER_QUALIFICATION_SEPARATOR)
    .map(part => part.trim())
    .filter(Boolean);
  if (parts.some(part => normalizePartnerName(part) === normalizePartnerName(incoming))) {
    return current;
  }
  return [...parts, incoming.trim()].join(PARTNER_QUALIFICATION_SEPARATOR);
}

/**
 * A Receita lista a mesma pessoa uma vez por cargo (card 3578). Devolve um sócio por pessoa, na ordem em que
 * apareceram, com os cargos diferentes juntos na qualificação. Mesma pessoa = mesmo nome, sem diferença de caixa,
 * acento ou espaço.
 */
export function dedupePartnersByName(partners: CompanyPartner[]): CompanyPartner[] {
  const kept = new Map<string, CompanyPartner>();
  const result: CompanyPartner[] = [];
  for (const partner of partners) {
    if (!partner.name?.trim()) continue;
    const key = normalizePartnerName(partner.name);
    const existing = kept.get(key);
    if (!existing) {
      const copy = { ...partner };
      kept.set(key, copy);
      result.push(copy);
      continue;
    }
    existing.qualification = mergeQualifications(existing.qualification, partner.qualification);
    if (!existing.countryOfOrigin) existing.countryOfOrigin = partner.countryOfOrigin;
    if (!existing.legalRepresentativeName) {
      existing.legalRepresentativeName = partner.legalRepresentativeName;
      existing.legalRepresentativeQualification = partner.legalRepresentativeQualification;
    }
  }
  return result;
}
